import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyCall } from "@/components/StickyCall";
import Home from "@/pages/Home";
import Equipment from "@/pages/Equipment";
import CategoryPage from "@/pages/CategoryPage";
import Contact from "@/pages/Contact";
import SellSurplus from "@/pages/SellSurplus";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import { CATEGORIES } from "@/data/content";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-ves-black font-body text-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/equipment" element={<Equipment />} />
            {Object.entries(CATEGORIES).map(([slug, cat]) => (
              <Route key={slug} path={`/${slug}`} element={<CategoryPage cat={cat} />} />
            ))}
            <Route path="/about" element={<About />} />
            <Route path="/sell-your-surplus" element={<SellSurplus />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <StickyCall />
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
